/* GERADO por scripts/relayout/81-lp-v3.py (lp/v3/src/js): base + descanso */
(() => {
/* ---------- Ajudantes de escopo: o build prefixa classes (z3-) e ids (zlp3-) no HTML e no CSS; aqui o JS faz o mesmo ---------- */
const R = document.getElementById('zlp3');
const D = JSON.parse(document.getElementById('zlp3-d').textContent);
const S = (sel) => sel.replace(/\.(-?[_a-zA-Z][\w-]*)/g, '.z3-$1').replace(/#([_a-zA-Z][\w-]*)/g, '#zlp3-$1');   // seletor
const $ = (sel, c = R) => c.querySelector(S(sel));
const $$ = (sel, c = R) => [...c.querySelectorAll(S(sel))];
const I = (id) => document.getElementById('zlp3-' + id);
const C = (n) => 'z3-' + n;                                                                                       // classe
const H = (html) => html                                                                                          // HTML montado no JS
  .replace(/\bclass="([^"]*)"/g, (m, v) => 'class="' + v.split(/\s+/).filter(Boolean).map(C).join(' ') + '"')
  .replace(/\b(id|for)="([^"]+)"/g, (m, a, v) => `${a}="zlp3-${v}"`)
  .replace(/\bhref="#([^"]+)"/g, 'href="#zlp3-$1"');
const folha = (tipo) => (D.folhas || []).find(f => f.tipo === tipo);
const modal = (tipo) => (D.modais || []).find(f => f.tipo === tipo);
const RM = matchMedia('(prefers-reduced-motion: reduce)');
const DESK = matchMedia('(min-width: 900px)');
const fmt = (x) => String(Math.round(x * 10) / 10).replace('.', ',');
/* Modal "Seu pet cabe?" sem ficha (sem medida/peso confiável no cadastro): NÃO calcula. Junta o que o cliente preencheu e manda ao WhatsApp.
   Campos, rótulos e mensagens vêm do JSON (modal.campos, aria_sp, msg0/msg1, res0/res1, why0). esp = () => rótulo da espécie escolhida (opcional). */
const semFicha = (M) => !M.ficha || M.modo === 'whatsapp';
const numCampo = (el) => { const s = el.value.trim().replace(',', '.'); const x = parseFloat(s); return s && isFinite(x) && x > 0 ? x : null; };
function modalWa(M, esp) {
  const campos = M.campos.map(c => [c, I(c.id)]), lv = I('fitLv'), why = I('fitWhy'), wa = I('fitWa'), res = I('fitRes'), altBox = I('fitAlt');
  return () => {
    const vals = campos.map(([c, el]) => [c, numCampo(el)]).filter(x => x[1]);
    const nome = esp && esp();
    const linhas = (nome && M.aria_sp ? [`${M.aria_sp}: ${nome}`] : []).concat(vals.map(([c, v]) => `${c.label}: ${fmt(v)} ${c.un}`));
    delete res.dataset.lv; altBox.hidden = true; altBox.innerHTML = '';
    lv.textContent = vals.length ? (M.res1 || M.res0) : M.res0;
    why.innerHTML = vals.length ? linhas.map(t => `<li>${t}</li>`).join('') : `<li>${M.why0}</li>`;
    wa.href = `https://wa.me/${D.whatsapp}?text=${encodeURIComponent(vals.length ? `${M.msg1}\n${linhas.join('\n')}` : M.msg0)}`;
  };
}
const ar = (s) => { const [w, h] = String(s).split('/').map(Number); return w / h; };

/* ---------- Anatomia com chamadas e linha-guia (pinos x,y em % da foto; rótulo em lx,ly) ---------- */
(() => {
  const svg = I('coSvg'); if (!svg) return;
  const an = folha('anatomia'), im = D.img[an.img], W = im.w, H0 = im.h, ns = 'http://www.w3.org/2000/svg';
  const lbl = I('coLbl'), leg = I('legend');
  an.pinos.forEach((c, i) => {
    const px = c.x / 100 * W, py = c.y / 100 * H0, ex = c.lx / 100 * W, ey = c.ly / 100 * H0;
    const kx = c.r ? Math.max(px + 40, ex - 160) : Math.min(px - 40, ex + 160);
    const pl = document.createElementNS(ns, 'polyline');
    pl.setAttribute('points', `${px},${py} ${kx},${ey} ${ex},${ey}`); pl.setAttribute('pathLength', '1');
    pl.style.transitionDelay = (i * 0.12) + 's';
    const ring = document.createElementNS(ns, 'circle'); ring.setAttribute('class', C('ring')); ring.setAttribute('cx', px); ring.setAttribute('cy', py); ring.setAttribute('r', 11);
    const dot = document.createElementNS(ns, 'circle'); dot.setAttribute('class', C('dot')); dot.setAttribute('cx', px); dot.setAttribute('cy', py); dot.setAttribute('r', 4);
    svg.append(pl, ring, dot);
    const d = document.createElement('div'); d.className = C('lbl') + (c.r ? ' ' + C('r') : '');
    d.style.left = c.lx + '%'; d.style.top = c.ly + '%'; d.style.transitionDelay = (0.7 + i * 0.12) + 's';
    d.innerHTML = `${c.t}<small>${c.s}</small>`; lbl.append(d);
    const n = document.createElement('span'); n.className = C('num'); n.textContent = i + 1; n.style.left = c.x + '%'; n.style.top = c.y + '%'; lbl.append(n);
    const li = document.createElement('li'); li.innerHTML = `<i>${i + 1}</i><span>${c.m || c.t}</span>`; leg.append(li);
  });
  const plate = I('plate');
  new IntersectionObserver((es, o) => es.forEach(e => {
    if (e.isIntersecting) { plate.classList.add(C('drawn')); o.disconnect(); }
  }), { threshold: 0.35 }).observe(plate);
})();

/* ---------- Visualizador (desenho técnico e "por que importa") ---------- */
const viewer = I('viewer'), vs = I('vscroll'), vimg = I('vimg');
let lastFocus = null;
const openViewer = (src, a, alt) => {
  lastFocus = document.activeElement;
  vimg.src = src; vimg.alt = alt; vs.style.setProperty('--ar', a); vs.classList.remove(C('z')); viewer.showModal();
};
if (I('openBp')) I('openBp').onclick = () => {
  const b = I('openBp'), mob = matchMedia('(max-width:759px)').matches;
  openViewer(mob ? b.dataset.m : b.dataset.d, ar(mob ? b.dataset.arm : b.dataset.ard), b.dataset.alt);
};
if (I('openFis')) I('openFis').onclick = () => { const b = I('openFis'); openViewer(b.dataset.src, ar(b.dataset.ar), b.dataset.alt); };
I('vClose').onclick = () => viewer.close();
viewer.addEventListener('click', e => { if (e.target === viewer) viewer.close(); });
viewer.addEventListener('close', () => lastFocus && lastFocus.focus());
vimg.onclick = (e) => {
  const r = vimg.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
  vs.classList.toggle(C('z'));
  if (vs.classList.contains(C('z'))) requestAnimationFrame(() => {
    vs.scrollLeft = fx * vs.scrollWidth - vs.clientWidth / 2; vs.scrollTop = fy * vs.scrollHeight - vs.clientHeight / 2;
  });
};

/* ---------- Carrossel genérico (gestos e perguntas) ---------- */
function carousel({ track, items, prev, next, count, bar, onIndex }) {
  let cur = 0;
  const n = items.length;
  const idxNow = () => {
    const max = track.scrollWidth - track.clientWidth;
    return max > 0 ? Math.round(track.scrollLeft / max * (n - 1)) : 0;
  };
  const paint = (i) => {
    cur = i;
    count.textContent = `${i + 1}/${n}`;
    bar.style.transform = `scaleX(${(i + 1) / n})`;
    prev.disabled = i === 0; next.disabled = i === n - 1;
    onIndex && onIndex(i);
  };
  const go = (i) => {
    i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: RM.matches ? 'auto' : 'smooth' });
    paint(i);
  };
  let raf = 0;
  track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = idxNow(); if (i !== cur) paint(i); }); }, { passive: true });
  prev.addEventListener('click', () => go(cur - 1));
  next.addEventListener('click', () => go(cur + 1));
  track.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
  });
  paint(0);
  return { go, get i() { return cur; } };
}

// Gestos: carrossel no celular, foto fixa que troca no desktop
if (I('steps')) {
  const steps = $$('.step'), gImgs = $$('.g-fig img'), nS = steps.length;
  const gN = I('gN'), gP = I('gP');
  const setStep = (i) => {
    steps.forEach((s, k) => s.classList.toggle(C('on'), k === i));
    gImgs.forEach((im, k) => im.classList.toggle(C('on'), k === i));
    gN.textContent = `Passo ${i + 1} de ${nS}`; gP.parentElement.style.setProperty('--p', (i + 1) / nS);
  };
  carousel({ track: I('steps'), items: steps, prev: I('gPrev'), next: I('gNext'),
    count: I('gCount'), bar: I('gBar'), onIndex: (i) => { if (!DESK.matches) setStep(i); } });
  const stepIO = new IntersectionObserver((es) => {
    if (!DESK.matches) return;
    es.forEach(e => { if (e.isIntersecting) setStep(steps.indexOf(e.target)); });
  }, { rootMargin: '-45% 0px -45% 0px' });
  steps.forEach(s => stepIO.observe(s));
}

// Perguntas: carrossel no celular, índice no desktop
if (I('track')) {
  const idxBtns = $$('#qIdx button');
  const qc = carousel({ track: I('track'), items: $$('.qc'), prev: I('qPrev'), next: I('qNext'),
    count: I('qCount'), bar: I('qBar'),
    onIndex: (i) => idxBtns.forEach((b, k) => b.setAttribute('aria-current', String(k === i))) });
  idxBtns.forEach((b, k) => b.addEventListener('click', () => qc.go(k)));
}

/* ---------- Cor: estado único, compartilhado por bloco de cores, comparativo e palco ---------- */
const COR = Object.fromEntries((D.cores || []).map(c => [c.k, c]));
let cor = R.querySelector('img[data-cor].z3-on')?.dataset.cor || (D.cores && D.cores[0] && D.cores[0].k);
$$('[data-sw]').forEach(g => {
  g.innerHTML = H(Object.entries(COR).map(([k, c]) =>
    `<button class="sw" type="button" role="radio" data-k="${k}" aria-label="${c.curto || c.nome}" aria-checked="${k === cor}" tabindex="${k === cor ? 0 : -1}" style="--c:${c.hex}"><i></i></button>`).join(''));
  g.addEventListener('click', e => { const b = e.target.closest(S('.sw')); if (b) setCor(b.dataset.k); });
  g.addEventListener('keydown', e => {
    const ks = Object.keys(COR), d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (!d) return;
    e.preventDefault();
    const k = ks[(ks.indexOf(cor) + d + ks.length) % ks.length];
    setCor(k); g.querySelector(`[data-k="${k}"]`).focus();
  });
});
function setCor(k) {
  if (k === cor) return;
  cor = k;
  $$('.sw').forEach(b => { const on = b.dataset.k === k; b.setAttribute('aria-checked', on); b.tabIndex = on ? 0 : -1; });
  $$('img[data-cor]').forEach(im => { if (im.dataset.cor === k) im.loading = 'eager'; im.classList.toggle(C('on'), im.dataset.cor === k); });
  $$('[data-cor-nome]').forEach(el => { el.textContent = el.closest(S('.stage')) ? (COR[k].curto || COR[k].nome) : COR[k].nome; });
  kick();
}
if (I('pickCor')) I('pickCor').onclick = () => I('oferta').scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth' });
// shortcut: o CTA rola até a compra da PDP (topo); se a PDP ganhar âncora própria do formulário, apontar para ela
if (I('buy')) I('buy').onclick = () => window.scrollTo({ top: 0, behavior: RM.matches ? 'auto' : 'smooth' });

/* ---------- Palco: entrada com spring (damping .86, response .55 s), interrompível ---------- */
const obj = I('obj');
const SP = { k: Math.pow(2 * Math.PI / 0.55, 2), c: 4 * Math.PI * 0.86 / 0.55 };
let p = 1, v = 0, target = 1, running = false, last = 0;
const render = () => {
  const q = Math.max(0, p);
  obj.style.transform = `translate3d(0,${(1 - q) * 56}px,0) scale(${0.93 + 0.07 * q})`;
  obj.style.opacity = Math.min(1, q * 1.5);
};
const tick = (t) => {
  const dt = Math.min(0.032, (t - last) / 1000 || 0.016); last = t;
  v += (-SP.k * (p - target) - SP.c * v) * dt; p += v * dt;   // parte do valor atual: nunca salta
  render();
  if (Math.abs(p - target) < 0.0005 && Math.abs(v) < 0.0005) { p = target; v = 0; render(); running = false; return; }
  requestAnimationFrame(tick);
};
const run = () => { if (!running) { running = true; last = performance.now(); requestAnimationFrame(tick); } };
function kick() { if (RM.matches || !obj) return; v -= 0.9; run(); }   // troca de cor: leve respiro do objeto
if (obj && !RM.matches) {
  const r = obj.getBoundingClientRect();
  if (r.top > innerHeight) { p = 0; render(); }
  new IntersectionObserver((es, o) => es.forEach(e => {
    if (e.isIntersecting) { target = 1; run(); o.disconnect(); }
  }), { threshold: 0.2 }).observe(obj);
}

/* ---------- Descanso (cama): ajustes sobre os módulos comuns ---------- */
(() => {
  // botão "Qual serve?" na oferta (abre o modal; o oferta comum não tem esse espaço)
  const of = folha('oferta'), pc = $('#oferta .p-card');
  if (of && of.p_size && pc) pc.insertAdjacentHTML('afterend', H(`<button class="p-size" type="button" data-fit>${of.p_size}</button>`));
  // gestos: o base escreve "Passo n de N"; aqui a palavra vem do JSON
  const g = folha('gestos'), gN = I('gN');
  if (g && g.palavra && gN) new MutationObserver(() => { if (gN.textContent.startsWith('Passo')) gN.textContent = gN.textContent.replace('Passo', g.palavra); }).observe(gN, { childList: true });
  // amostra de cor com miolo (parede externa = hex, interior = ci)
  const CI = Object.fromEntries((D.cores || []).map(c => [c.k, c.ci]));
  $$('.sw').forEach(b => CI[b.dataset.k] && b.style.setProperty('--ci', CI[b.dataset.k]));
})();

/* ---------- Anatomia: pinos tocáveis + lista ---------- */
(() => {
  const plate = I('plate'), alist = I('alist'), an = folha('anatomia'); if (!alist || !an) return;
  let on = -1;
  const setPin = (i) => {
    on = on === i ? -1 : i;
    $$('.pin', plate).forEach((p, k) => { p.classList.toggle(C('on'), k === on); p.setAttribute('aria-pressed', k === on); });
    [...alist.children].forEach((li, k) => li.classList.toggle(C('on'), k === on));
    alist.classList.toggle(C('dim'), on > -1);
  };
  an.partes.forEach((c, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = C('pin'); b.style.left = c.x + '%'; b.style.top = c.y + '%';
    b.style.transitionDelay = (i * 0.09) + 's';
    b.setAttribute('aria-label', `${i + 1}: ${c.t}, ${c.s}`); b.setAttribute('aria-pressed', 'false');
    b.innerHTML = `<i>${i + 1}</i>`; b.onclick = () => setPin(i);
    plate.append(b);
    const li = document.createElement('li');
    li.innerHTML = `<i>${i + 1}</i><b>${c.t}</b><span>${c.s}</span>`;
    li.addEventListener('mouseenter', () => { if (on !== i) setPin(i); });
    alist.append(li);
  });
  alist.addEventListener('mouseleave', () => { if (on > -1) setPin(on); });
  new IntersectionObserver((es, o) => es.forEach(e => {
    if (e.isIntersecting) { plate.classList.add(C('drawn')); o.disconnect(); }
  }), { threshold: 0.35 }).observe(plate);
})();

/* ---------- Ano inteiro: verão × inverno ---------- */
(() => {
  const seg = I('seg'), F = folha('ano'); if (!seg || !F) return;
  const ANO = Object.fromEntries(F.estacoes.map(e => [e.s, e])), ks = Object.keys(ANO);
  const segB = $$('button', seg), imgs = $$('#yrFig img'), sw = I('yrSwap');
  let est = ks[0], t = 0;
  const setEst = (s) => {
    if (s === est) return;
    est = s; seg.dataset.s = s; seg.style.setProperty('--i', ks.indexOf(s));
    segB.forEach(b => { const v = b.dataset.s === s; b.setAttribute('aria-checked', v); b.tabIndex = v ? 0 : -1; });
    imgs.forEach(im => { if (im.dataset.s === s) im.loading = 'eager'; im.classList.toggle(C('on'), im.dataset.s === s); });
    const a = ANO[s];
    I('yrChip').textContent = a.chip;
    clearTimeout(t); sw.classList.add(C('out'));
    t = setTimeout(() => {
      I('yrK').textContent = a.k; I('yrL').textContent = a.l;
      a.d.forEach((x, k) => { I('yr' + (k + 1)).textContent = x; });
      sw.classList.remove(C('out'));
    }, RM.matches ? 0 : 160);
  };
  const outra = () => ks[(ks.indexOf(est) + 1) % ks.length];
  segB.forEach(b => b.addEventListener('click', () => setEst(b.dataset.s)));
  seg.addEventListener('keydown', e => {
    if (!['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
    e.preventDefault(); setEst(outra()); seg.querySelector(`[data-s="${est}"]`).focus();
  });
  I('yrFig').addEventListener('click', () => setEst(outra()));
  // pré-carrega a outra foto quando a folha se aproxima: a troca é instantânea
  new IntersectionObserver((es, o) => es.forEach(e => { if (e.isIntersecting) { imgs.forEach(im => im.loading = 'eager'); o.disconnect(); } }), { rootMargin: '400px 0px' }).observe(seg);
})();

/* ---------- Modal "Seu pet cabe?" (descanso · cama): pelo peso, comprimento deitado confirma ---------- */
(() => {
  const M = modal('cabe'); if (!M || !I('fit')) return;
  const FICHA = M.ficha, RACAS = M.racas && M.racas.dados, ALT = M.alt, SEM = semFicha(M);
  const fit = I('fit'), fP = I('fPeso'), fC = I('fComp');
  const altBox = I('fitAlt'), res = I('fitRes'), lv = I('fitLv'), why = I('fitWhy'), wa = I('fitWa');
  const num = (el) => { const s = el.value.trim().replace(',', '.'); const x = parseFloat(s); return s && isFinite(x) && x > 0 ? x : null; };
  const TS = SEM ? [] : Object.entries(FICHA.tamanhos), [UT, UM] = TS[TS.length - 1] || [];
  // menor tamanho que comporta peso (e comprimento, se houver); perto do teto → "limite" e sobe um tamanho quando existe
  function avalia(peso, comp) {
    for (let i = 0; i < TS.length; i++) {
      const [tam, t] = TS[i];
      if (peso > t.peso || (comp && comp > t.medida[0])) continue;
      const justo = peso > t.peso * FICHA.margemPeso || (comp && comp > t.medida[0] - FICHA.margemCm);
      const maior = TS[i + 1] && TS[i + 1][0];
      return { n: justo ? 'limite' : 'folga', tam, t, sobe: justo ? maior : null };
    }
    return { n: 'nao' };
  }
  const titulo = (r) => r.n === 'nao' ? 'Não recomendamos esta cama' : r.n === 'folga' ? `Tamanho ${r.tam}: cabe com folga` : r.sobe ? `No limite do ${r.tam}: fique com o ${r.sobe}` : `Cabe no ${r.tam}, no limite: confirme`;
  const waUp = SEM && modalWa(M);
  function update() {
    if (SEM) return waUp();
    const peso = num(fP), comp = num(fC);
    let msg = M.msg0;
    if (peso) {
      const r = avalia(peso, comp);
      res.dataset.lv = r.n;
      lv.textContent = titulo(r);
      const li = [];
      if (r.n !== 'nao') {
        li.push(`${fmt(peso)} kg; o ${r.tam} vai até ${fmt(r.t.peso)} kg.`);
        if (comp) li.push(`Deitado, ele mede ${fmt(comp)} cm; o ${r.tam} mede ${r.t.medida[0]} x ${r.t.medida[1]} cm.`);
        if (r.sobe) li.push('Na dúvida entre dois tamanhos, fique com o maior: ele se estica sem o corpo sair da borda.');
        else if (r.n === 'limite') li.push('Fale com a gente antes de comprar e confirmamos.');
      } else {
        li.push(peso > UM.peso ? `${fmt(peso)} kg passa do ${UT}, que vai até ${fmt(UM.peso)} kg.` : `Deitado, ele mede ${fmt(comp)} cm; o ${UT} mede ${UM.medida[0]} x ${UM.medida[1]} cm.`);
      }
      if (fonte) li.push(`Peso típico da tabela para ${fonte}. Pese o seu para confirmar.`);
      why.innerHTML = li.map(t => `<li>${t}</li>`).join('');
      altBox.hidden = r.n !== 'nao';
      altBox.innerHTML = r.n !== 'nao' ? '' : H(`<p>${M.alt_t}</p><a href="${ALT.href}"><span class="th" aria-hidden="true">${ALT.th}</span><span><b>${ALT.nome}</b><small>${ALT.spec}</small></span><svg class="ico" aria-hidden="true"><use href="#i-r"/></svg></a>`);
      msg = `${M.msg1}\nPeso: ${fmt(peso)} kg\nComprimento deitado (focinho à base da cauda): ${comp ? fmt(comp) + ' cm' : 'não medi'}\nResultado na página: ${titulo(r)}${fonte ? '\nRaça (média da tabela): ' + fonte : ''}`;
    } else {
      delete res.dataset.lv; altBox.hidden = true; altBox.innerHTML = '';
      lv.textContent = M.res0;
      why.innerHTML = `<li>${M.why0}</li>`;
    }
    wa.href = `https://wa.me/${D.whatsapp}?text=${encodeURIComponent(msg)}`;
  }
  let fonte = null;
  const campos = M.campos.map(c => I(c.id));   // ids vêm do JSON (fPeso/fComp na cama; fCab, fAlt... nas famílias sem ficha)
  campos.forEach(el => el.addEventListener('input', () => { if (el === fP) fonte = null; update(); }));
  I('fitForm').addEventListener('submit', e => e.preventDefault());
  let fitFrom = null;
  $$('[data-fit]').forEach(b => b.addEventListener('click', () => { fitFrom = b; showMain(); update(); fit.showModal(); I('fitH').focus(); }));   // foco no título: nenhum campo abre o teclado sozinho
  I('fitClose').onclick = () => fit.close();
  $$('[data-close]', fit).forEach(b => b.onclick = () => fit.close());

  /* ---------- Tabela de raças (mesma regra do modal, pelo peso) ---------- */
  const main = I('fitMain'), rc = I('racas'), rcList = I('rcList'), rcQ = I('rcQ'), rcEmpty = I('rcEmpty'), rcOpen = I('rcOpen');
  const tabs = rc ? [...rc.querySelectorAll('[role=tab]')] : [];
  const VI = { folga: 'i-ok', limite: 'i-ap', nao: 'i-x' };
  const norm = (t) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const mid = (a, b) => Math.round((a + b) / 2 * 10) / 10;
  let sp = tabs[0] && tabs[0].dataset.sp;
  function showMain() { if (rc) rc.hidden = true; main.hidden = false; fit.classList.remove(C('wide')); }
  function showRacas() { main.hidden = true; rc.hidden = false; fit.classList.add(C('wide')); fit.scrollTop = 0; renderRacas(); I('rcH').focus(); }
  function renderRacas() {
    const q = norm(rcQ.value.trim());
    const rows = RACAS[sp].filter(r => !q || norm(r[0]).includes(q));
    rcList.innerHTML = H(rows.map(([nome, porte, p1, p2]) => {
      // média da faixa; se ela não cabe mas o adulto mais leve cabe, entra como "no limite" e preenche com ele
      let pv = mid(p1, p2), r = avalia(pv, null);
      if (r.n === 'nao' && avalia(p1, null).n !== 'nao') { pv = p1; r = { ...avalia(p1, null), n: 'limite' }; }
      const vt = r.n === 'nao' ? `Acima de ${fmt(UM.peso)} kg` : r.sobe ? `Fique com o ${r.sobe}` : r.n === 'limite' ? `${r.tam}, no limite` : `Tamanho ${r.tam}`;
      const peso = `${fmt(p1)}–${fmt(p2)} kg`;
      return `<li><button class="rc-row" type="button" data-nome="${nome}" data-p="${pv}" aria-label="${nome}: porte ${porte}, ${peso}, na cama: ${vt}. Preencher o formulário">` +
        `<span class="rc-n">${nome}</span><span class="rc-m"><span>${porte[0].toUpperCase() + porte.slice(1)}</span><span>${peso}</span></span>` +
        `<span class="rc-v" data-lv="${r.n}"><svg class="ico" aria-hidden="true"><use href="#${VI[r.n]}"/></svg>${vt}</span></button></li>`;
    }).join(''));
    rcEmpty.hidden = rows.length > 0;
  }
  if (rc) {
  rcOpen.addEventListener('click', showRacas);
  I('rcBack').onclick = () => { showMain(); rcOpen.focus(); };
  rcQ.addEventListener('input', renderRacas);
  const setTab = (t) => {
    sp = t.dataset.sp;
    tabs.forEach(b => { const v = b === t; b.setAttribute('aria-selected', v); b.tabIndex = v ? 0 : -1; });
    rcList.setAttribute('aria-labelledby', t.id); renderRacas();
  };
  tabs.forEach(t => t.addEventListener('click', () => setTab(t)));
  rc.querySelector('[role=tablist]').addEventListener('keydown', e => {
    const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key]; if (!d) return;
    e.preventDefault(); const t = tabs[(tabs.indexOf(document.activeElement) + d + tabs.length) % tabs.length]; setTab(t); t.focus();
  });
  rcList.addEventListener('click', e => {
    const b = e.target.closest(S('.rc-row')); if (!b) return;
    fP.value = fmt(+b.dataset.p); fonte = b.dataset.nome;
    showMain(); update(); fit.scrollTop = 0;
    requestAnimationFrame(() => { res.scrollIntoView({ block: 'nearest', behavior: RM.matches ? 'auto' : 'smooth' }); res.focus({ preventScroll: true }); });
  });
  }
  fit.addEventListener('click', e => { if (e.target === fit) fit.close(); });
  fit.addEventListener('close', () => fitFrom && fitFrom.focus());
  fit.addEventListener('keydown', e => {
    if (e.key !== 'Tab') return;
    const f = [...fit.querySelectorAll('button,input,a[href]')].filter(x => x.offsetParent && x.tabIndex >= 0);
    const a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });
  if (!SEM) window.__fit = avalia; // usado pelo teste de aceite
})();

})();
